import * as THREE from 'three'
import Experience from '../Experience'

export default class West {
  constructor() {
    //setup
    this.experience = new Experience()
    this.scene = experience.scene
    this.resources = experience.resources
    this.time = experience.time
    this.debug = experience.debug

    if (this.debug.active) {
    }

    //options
    this.resource = this.resources.items.west

    //methods
    this.setMaterial()
    this.setModel()
    this.hidePart()
  }
  setMaterial() {
    //west facade
    this.westTexture = this.resources.items.westTexture
    this.westTexture.flipY = false
    this.westTexture.encoding = THREE.sRGBEncoding
    this.westMaterial = new THREE.MeshBasicMaterial({ map: this.westTexture })

    //Tv screen
    this.tvTexture = this.resources.items.tvTexture
    this.tvTexture.flipY = false
    this.tvTexture.encoding = THREE.sRGBEncoding
    this.tvMaterial = new THREE.MeshBasicMaterial({ map: this.tvTexture })

    //Big logo center
    this.logoTexture = this.resources.items.logoTexture
    this.logoTexture.flipY = false
    this.logoTexture.encoding = THREE.sRGBEncoding
    this.logoMaterial = new THREE.MeshBasicMaterial({ map: this.logoTexture, transparent: true })

    //Rennes metropole
    this.rennesMetropoleTexture = this.resources.items.rennesMetropole
    this.rennesMetropoleTexture.flipY = false
    this.rennesMetropoleTexture.encoding = THREE.sRGBEncoding
    this.rennesMetropoleMaterial = new THREE.MeshBasicMaterial({ map: this.rennesMetropoleTexture, transparent: true })

    //Name
    this.nameWhiteMaterial = new THREE.MeshBasicMaterial(0xffffff)
    this.nameRedMaterial = new THREE.MeshBasicMaterial(0xff0000)
  }

  setModel() {
    this.model = this.resource.scene
    this.model.scale.set(0.4, 0.4, 0.4)

    //west
    const west = this.model.children.find(child => child.name === 'west')
    west.material = this.westMaterial

    //TV screen
    const tvScreen1 = this.model.children.find(child => child.name === 'tv-screen001')
    tvScreen1.material = this.tvMaterial

    //Logos
    const logoCenter = this.model.children.find(child => child.name === 'logo-center001')
    const logoLeft = this.model.children.find(child => child.name === 'logo-left002')
    const logoRight = this.model.children.find(child => child.name === 'logo-right003')
    const logoFrontLeft = this.model.children.find(child => child.name === 'logo-front-left002')
    const logoFrontRight = this.model.children.find(child => child.name === 'logo-front-right002')

    logoCenter.material = this.logoMaterial
    logoLeft.material = this.logoMaterial
    logoRight.material = this.logoMaterial
    logoFrontLeft.material = this.logoMaterial
    logoFrontRight.material = this.logoMaterial

    //Names
    const nameWhite = this.model.children.find(child => child.name === 'name-white001')
    const nameRed = this.model.children.find(child => child.name === 'name-red001')
    nameWhite.material = this.nameWhiteMaterial
    nameRed.material = this.nameRedMaterial

    //Rennes metropole
    const rennesMetropole1 = this.model.children.find(child => child.name === 'rennes-metropole1001')
    const rennesMetropole2 = this.model.children.find(child => child.name === 'rennes-metropole2001')
    rennesMetropole1.material = this.rennesMetropoleMaterial
    rennesMetropole2.material = this.rennesMetropoleMaterial

    this.scene.add(this.model)
  }

  hidePart() {
    const ctrl = document.querySelector('.west .slider')
    ctrl.addEventListener('click', () => {
      this.model.traverse(child => {
        if (child instanceof THREE.Mesh && child.visible === true) {
          child.visible = false
        } else child.visible = true
      })
    })
  }
}
